import { createSlice } from "@reduxjs/toolkit";

const perfCycleSlice = createSlice({
  name: "perfCycle",
  initialState: { value: {}, isLocked: false },
  reducers: {
    perfCycleDetails: (state, action) => {
      state.value = action.payload;
    },
    setPerfCycleLocked: (state, action) => {
      state.isLocked = action.payload;
    },
  },
});

export const { perfCycleDetails, setPerfCycleLocked } = perfCycleSlice.actions;
export default perfCycleSlice.reducer;
